export const getAppUser = ({
  appUser
}) => appUser;